module.exports = __webpack_public_path__ + "img/hero-brand-banner.83ac01c.png";